// withAdminAuth.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAdminAuthenticated } from './auth';

const withAdminAuth = (WrappedComponent) => {
  return (props) => {
    if (!isAdminAuthenticated()) {
      return <Navigate to="/login" />;
    }
    return <WrappedComponent {...props} />;
  };
};

export default withAdminAuth;